// composables/useDebounce.js
import { ref, onUnmounted } from 'vue';

export function useDebounce() {
  const timeout = ref(null);

  const debounce = (func, wait) => {
    return (...args) => {
      if (timeout.value) {
        clearTimeout(timeout.value);
      }
      timeout.value = setTimeout(() => {
        func(...args);
      }, wait);
    };
  };

  onUnmounted(() => {
    if (timeout.value) {
      clearTimeout(timeout.value);
    }
  });

  return { debounce };
}
